export enum JobClassifierCategory {
  LIKELY_PROJECT = 'likely_project',
  UNKNOWN = 'unknown',
  LIKELY_CONTEST = 'likely_contest',
}

export enum ContestFormat {
  IMAGE = 'image',
  TEXT = 'text',
  VIDEO = 'video',
}

export interface JobClassifierGetResult {
  readonly id: string;
  readonly jobs: readonly number[];
  readonly category: JobClassifierCategory;
  readonly contest_format: ContestFormat;
}

export interface JobClassifierGetResultAjax {
  readonly [index: string]: JobClassifierGetResult;
}
